import {createContext} from '@lit/context';
import {Curator} from '../../@types/wishlist.js';

export interface CuratorLayerState {
  open: boolean;
  curator?: Curator;
  update: (newState: Partial<CuratorLayerState>) => void;
}

export const curatorLayerContext = createContext<CuratorLayerState>('curatorLayerContext');
